export enum CurrentView {
  List,
  Add,
  Edit,
}
